import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';

export default function VariantStatusBanner({ variantStatus, noMosipVariantMessage }) {
  if (noMosipVariantMessage) {
    return (
      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>No MOSIP variant</AlertTitle>
        <AlertDescription>{noMosipVariantMessage}</AlertDescription>
      </Alert>
    );
  }

  if (!variantStatus) return null;

  if (variantStatus.isMinexBlocked) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>MINEX variant not available</AlertTitle>
        <AlertDescription>{variantStatus.blockedReason}</AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isNistBlocked) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>NIST variant not available</AlertTitle>
        <AlertDescription>{variantStatus.blockedReason}</AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isRawBlocked) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Raw variant blocked</AlertTitle>
        <AlertDescription>{variantStatus.blockedReason}</AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isMosipBlocked) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Not MOSIP variant</AlertTitle>
        <AlertDescription>
          Header is set to MOSIP but plain image input routes to /raw/. Upload an ISO record (e.g. .iso, .bin) for MOSIP variant testing.
        </AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isMinexVariant) {
    return (
      <Alert variant="success">
        <CheckCircle2 className="h-4 w-4" />
        <AlertTitle>Testing MINEX variant</AlertTitle>
        <AlertDescription>{variantStatus.endpointPath} · ANSI INCITS 378-2004</AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isNistVariant) {
    return (
      <Alert variant="success">
        <CheckCircle2 className="h-4 w-4" />
        <AlertTitle>Testing NIST variant</AlertTitle>
        <AlertDescription>{variantStatus.endpointPath} · FRVT template path</AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isRawVariant) {
    return (
      <Alert variant="success">
        <CheckCircle2 className="h-4 w-4" />
        <AlertTitle>Testing Raw variant</AlertTitle>
        <AlertDescription>{variantStatus.endpointPath} · plain image route</AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isMosipVariant) {
    return (
      <Alert variant="success">
        <CheckCircle2 className="h-4 w-4" />
        <AlertTitle>Testing MOSIP variant</AlertTitle>
        <AlertDescription>
          {variantStatus.endpointPath} · CTK-certified surface
        </AlertDescription>
      </Alert>
    );
  }

  if (variantStatus.isIsoVariant) {
    return (
      <Alert variant="success">
        <CheckCircle2 className="h-4 w-4" />
        <AlertTitle>Testing ISO variant</AlertTitle>
        <AlertDescription>{variantStatus.endpointPath}</AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{variantStatus.label}</AlertTitle>
      <AlertDescription>{variantStatus.endpointPath}</AlertDescription>
    </Alert>
  );
}
